import React, { useState } from 'react';
import { useDonation } from '../context/DonationContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCalendar, FiMapPin, FiHeart, FiArrowRight } = FiIcons;

function DonationSetup({ onSetup }) {
  const { dispatch } = useDonation();
  const [formData, setFormData] = useState({
    date: new Date().toISOString().split('T')[0],
    location: '',
    charity: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch({ type: 'START_DONATION', payload: formData });
    onSetup();
  };

  return (
    <div className="max-w-2xl mx-auto">
      <div className="text-center mb-8">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <SafeIcon icon={FiHeart} className="w-8 h-8 text-green-600" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Donation Details
        </h2>
        <p className="text-gray-600">
          Set up your donation information
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            <SafeIcon icon={FiCalendar} className="inline w-4 h-4 mr-2" />
            Donation Date *
          </label>
          <input
            type="date"
            value={formData.date}
            onChange={(e) => setFormData(prev => ({ ...prev, date: e.target.value }))}
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-200 focus:outline-none transition-all duration-200"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            <SafeIcon icon={FiMapPin} className="inline w-4 h-4 mr-2" />
            Donation Location *
          </label>
          <input
            type="text"
            value={formData.location}
            onChange={(e) => setFormData(prev => ({ ...prev, location: e.target.value }))}
            placeholder="e.g., Goodwill Store, Salvation Army Drop-off"
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-200 focus:outline-none transition-all duration-200"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            <SafeIcon icon={FiHeart} className="inline w-4 h-4 mr-2" />
            Charity Name (Optional)
          </label>
          <input
            type="text"
            value={formData.charity}
            onChange={(e) => setFormData(prev => ({ ...prev, charity: e.target.value }))}
            placeholder="e.g., Goodwill Industries"
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-200 focus:outline-none transition-all duration-200"
          />
        </div>

        <div className="pt-6">
          <button
            type="submit"
            className="w-full bg-gradient-to-r from-green-600 to-emerald-600 text-white py-4 px-6 rounded-xl font-semibold text-lg hover:from-green-700 hover:to-emerald-700 transition-all duration-200 flex items-center justify-center space-x-2 shadow-lg hover:shadow-xl"
          >
            <span>Start Adding Items</span>
            <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
          </button>
        </div>
      </form>
    </div>
  );
}

export default DonationSetup;